import React, { useEffect, useState, Fragment } from "react";
import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Table,
  message,
  Select,
  Badge,
  DatePicker,
  Input,
} from "antd";

import { SearchOutlined } from "@ant-design/icons";
import "./SPStockInventory.less";
import { Redirect } from "react-router-dom";
import { url } from "../../config/global";
import Axios from "axios";
import moment from "moment";

const { Content } = Layout;

const { RangePicker } = DatePicker;

const SPStockInventory = () => {
  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);

  const [disableExport, setDisableExport] = useState(false);

  const [keyItemNumber, setKeyItemNumber] = useState("");
  const [keySupplier, setKeySupplier] = useState("");
  const [rangeDate, setRangeDate] = useState([null, null]);

  const [dataSourceOut, setDataSourceOut] = useState([]);

  const columns = [
    {
      title: "Before Item",
      dataIndex: "item_number",
      sorter: false,
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      sorter: true,
    },
    {
      title: "Std Qty",
      dataIndex: "std_pack",
      sorter: true,
    },
    {
      title: "Qty In",
      dataIndex: "qty_in",
      sorter: true,
      render: (text, record) => {
        const result = record.std_pack * record.qty_in;
        return result;
      },
    },
    {
      title: "Qty Out",
      dataIndex: "qty_out",
      sorter: true,
      render: (text, record) => {
        const result = record.std_pack * record.qty_out;
        return result;
      },
    },
    {
      title: "Stock Qty",
      dataIndex: "stock_qty",
      sorter: true,
      render: (text, record) => {
        const result = record.std_pack * record.stock_qty;
        return result;
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      sorter: false,
    },
    {
      title: "Last Date In",
      dataIndex: "last_date_in",
      sorter: true,
    },

    {
      title: "Last Date Out",
      dataIndex: "last_date_out",
      sorter: true,
    },
  ];

  useEffect(() => {
    getDataStock();
  }, []);

  // useEffect(() => {
  //   const isDateFilled =
  //     rangeDate && rangeDate.length === 2 && rangeDate[0] && rangeDate[1];
  //   const isItemNumberFilled = keyItemNumber && keyItemNumber.trim() !== "";
  //   const isSupplierFilled = keySupplier && keySupplier.trim() !== "";
  //   setDisableExport(!(isDateFilled || isItemNumberFilled || isSupplierFilled));
  // }, [rangeDate, keySupplier, keyItemNumber]);

  const handleRangeChange = (dates) => {
    if (!dates) {
      setRangeDate(null);
    } else {
      setRangeDate(dates);
    }
  };

  const handleChange = (e, type) => {
    if (type == "item_number") {
      setKeyItemNumber(e.value);
    } else {
      setKeySupplier(e.value);
    }
  };

  const exportExcel = async () => {
    // const isDateFilled =
    // rangeDate && rangeDate.length === 2 && rangeDate[0] && rangeDate[1];
    // const isItemNumberFilled = keyItemNumber && keyItemNumber.trim() !== "";
    // const isSupplierFilled = keySupplier && keySupplier.trim() !== "";

    // if (!isDateFilled && !isItemNumberFilled && !isSupplierFilled) {
    //   message.error("Isi minimal salah satu  Filter Pencarian!");
    //   return;
    // }

    setDisableExport(true);
    setLoadingExport(true);
    try {
      const response = await Axios.get(
        `${url}/supplier_stock/stock_inventory`,
        {
          params: {
            item_number: keyItemNumber,
            supplier: keySupplier,
            start_date: rangeDate[0] ? rangeDate[0].format("YYYY-MM-DD") : "",
            end_date: rangeDate[1] ? rangeDate[1].format("YYYY-MM-DD") : "",
            role: sessionStorage.getItem("role"),
            for: "download",
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const urls = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const a = document.createElement("a");
      a.href = urls;
      a.download = "Stok Inventory.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setLoadingExport(false);
      setDisableExport(false);
    } catch (error) {
      message.error("Gagal export: " + error);
      setLoadingExport(false);
      setDisableExport(false);
    }
  };

  const getDataStock = () => {
    // const isDateFilled =
    //   rangeDate && rangeDate.length === 2 && rangeDate[0] && rangeDate[1];
    //   const isItemNumberFilled = keyItemNumber && keyItemNumber.trim() !== "";
    //   const isSupplierFilled = keySupplier && keySupplier.trim() !== "";

    //   if (!isDateFilled && !isItemNumberFilled && !isSupplierFilled) {
    //     message.error("Isi minimal salah satu  Filter Pencarian!");
    //     return;
    //   }

    setLoading(true);
    setDataSourceOut([]);
    const startDate = rangeDate?.[0]?.format("YYYY-MM-DD") || "";
    const endDate = rangeDate?.[1]?.format("YYYY-MM-DD") || "";

    Axios.get(`${url}/supplier_stock/stock_inventory`, {
      params: {
        item_number: keyItemNumber,
        supplier: keySupplier,
        start_date: startDate,
        end_date: endDate,
        role: sessionStorage.getItem("role"),
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setDataSourceOut(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Stock Inventory Supplier"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row type="flex" gutter={[10, 20]} justify="space-between">
                <Col
                  xs={24}
                  md={12}
                  lg={8}
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Button
                    loading={loadingExport}
                    disabled={disableExport}
                    onClick={exportExcel}
                    type="primary"
                  >
                    Export
                  </Button>
                </Col>

                <Col
                  xs={24}
                  md={12}
                  lg={16}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Input
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Search Item Number"
                    onChange={(e) => handleChange(e.target, "item_number")}
                    allowClear
                  />
                  <Input
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Search Supplier"
                    onChange={(e) => handleChange(e.target, "supplier")}
                    allowClear
                  />
                  <RangePicker
                    value={rangeDate}
                    onChange={handleRangeChange}
                    format="YYYY-MM-DD"
                  />
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={() => getDataStock()}
                  />
                </Col>

                <Col xs={24}>
                  <Table
                    scroll={{ x: 1300 }}
                    loading={loading}
                    rowClassName="editable-row"
                    bordered
                    dataSource={dataSourceOut.data}
                    rowKey={(data) => data._id}
                    columns={columns}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
};

export default SPStockInventory;
